import { kilometresToMiles } from '@/utils';
import { Avatar, Box, Chip, Tooltip } from '@mui/material';

export function SpeedChip({
  speedKilometresPerHour = 0,
  speedLimitKilometresPerHour = 0,
  brokenRules = [],
}) {
  const isSpeeding =
    speedLimitKilometresPerHour > 0 &&
    speedKilometresPerHour > speedLimitKilometresPerHour;

  return (
    <Tooltip title={brokenRules.join(', ') || ''}>
      <Chip
        color={isSpeeding ? 'error' : undefined}
        sx={{
          fontSize: '.6rem',
          height: 18,
          '&.MuiChip-sizeSmall .MuiChip-avatar': {
            bgcolor: 'background.paper',
            height: 14,
            width: 14,
            marginLeft: 0.25,
            fontSize: '0.5rem',
            fontWeight: 'bold',
          },
        }}
        size="small"
        avatar={
          speedLimitKilometresPerHour &&
          (isSpeeding || brokenRules.length > 0) ? (
            <Avatar>
              <Box
                sx={(theme) => ({
                  color: brokenRules.length
                    ? theme.palette.text.primary
                    : undefined,
                })}
              >
                {kilometresToMiles(speedLimitKilometresPerHour)}
              </Box>
            </Avatar>
          ) : undefined
        }
        label={`${kilometresToMiles(speedKilometresPerHour)} MPH`}
      />
    </Tooltip>
  );
}
